<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Presupuestos Internos Cancelados</strong>
          </div>
          <b-form>
            <b-form-group
              label="Fecha Desde"
              label-for="fechaDesde"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaDesde" 
                v-model="fechaDesde" 
                :state="fechaDesdeValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaDesdeFeedback">
                {{ fechaDesdeInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Hasta"
              label-for="fechaHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaHasta" 
                v-model="fechaHasta" 
                :state="fechaHastaValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaHastaFeedback">
                {{ fechaHastaInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarCliente">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !cliente,
                                  'fa fa-remove': cliente  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="cliente"
                  :value="clienteNombre"
                  readonly
                  type="text"
                  :state="clienteValido"/>
                <b-form-invalid-feedback id="clienteFeedback">
                  {{ clienteInvalidoMsj }}
                </b-form-invalid-feedback>          
              </b-input-group>
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <b-modal ref="searchClienteModal"
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        :incluirInactivos="true"
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment';

export default {
  name: 'ABM',
  components: {
    appSearchCliente: SearchCliente,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      fechaDesdeValida: null,
      fechaDesdeInvalidaMsj: '',
      fechaHastaValida: null,
      fechaHastaInvalidaMsj: '',
      clienteValido: null,
      clienteInvalidoMsj: '',

      fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
      fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
      cliente: null,

      labelCols: 2
    }
  },
  computed: {
    clienteNombre() {
      return this.cliente? this.cliente.nombre.trim() : '';
    }
  },
  created() {
    
  },  
  methods: {
    validate() {
    },
    exportXls () {
      let execute = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let clienteId = 0;
      if (this.cliente) {
        clienteId = this.cliente.id;
      }

      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        clienteId
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('presupuestosinternos/getRptPresupuestosCancelados', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rptPresupuestos = this.$store.getters['presupuestosinternos/rptPresupuestos'];

            if (rptPresupuestos) {
              if (rptPresupuestos.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              let title= 'Resumen de Presupuestos';
              let fileName = 'presupuestos-cancelados';
              let format = [
                { titulo: 'Nro.', nombre: 'presupuestoNumero', formato: '' },
                { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
                { titulo: 'Cliente', nombre: 'cliente', formato: '' },
                { titulo: 'Accion', nombre: 'accion', formato: '' },
                { titulo: 'Moneda', nombre: 'moneda', formato: '' },
                { titulo: 'Cotiz.USD', nombre: 'monedaCotizacion', formato: '' },
                { titulo: 'Total', nombre: 'importeTotal', formato: '' },
                { titulo: 'Nro.Orden', nombre: 'numeroOrdenCompra', formato: '' },
                { titulo: 'Fecha Cancelación', nombre: 'fechaCancelacion', formato: 'fecha' },
                { titulo: 'Usuario Cancel.', nombre: 'usuarioCancelacion', formato: '' },
                { titulo: 'Motivo', nombre: 'cancelacionMotivo', formato: '' },
                { titulo: 'Observaciones', nombre: 'observacionesCancelacion', formato: '' }
              ];

              this.exportXLS(title, fileName, rptPresupuestos, format);
            } else {
              this.showModalMsj('No hay datos para exportar.', null, null, 'light');
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    goBack() {

    },
    seleccionarCliente() {
      if (this.cliente) {
        this.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(item) {
      this.cliente = item;
      this.$refs.searchClienteModal.hide();
    },
    estadoActualizado(estado) {
      this.estado = estado;
    }
  },
}
</script>

<style>
</style>
